import { Injectable } from '@angular/core';
import { EPropertyXCode, IBookingPropertyDescription, IPropertyXCodeAndXApply } from "libraries/service/resources/booking/interfaces/IGetBookings";

@Injectable()
export class PropertyDescriptionService {

    private static readonly AUTHORIZED_IMPORTANT_INFORMATION_TYPES: EPropertyXCode[] =
        [EPropertyXCode.checkIn, EPropertyXCode.checkOut, EPropertyXCode.goodToKnow, EPropertyXCode.fee];

    public isDisplayableDescription(...descriptions: IBookingPropertyDescription[]): boolean {
        return descriptions
            .flatMap((desc: IBookingPropertyDescription) => desc.types)
            .some((type: IPropertyXCodeAndXApply) => type && PropertyDescriptionService.AUTHORIZED_IMPORTANT_INFORMATION_TYPES.includes(type.xCode));
    }

    public findByXCode(descriptions: IBookingPropertyDescription[], xCode: EPropertyXCode): IBookingPropertyDescription {
        const output: IBookingPropertyDescription = descriptions.find((description: IBookingPropertyDescription) =>
            description.types.some((type: IPropertyXCodeAndXApply) => type && type.xCode === xCode));

        if(output){
            // @ts-ignore
            if(!output.textLines && output.textLine && Array.isArray(output.textLine)){
                // @ts-ignore
                output.textLines = output.textLine;
            }
        }
        return output;
    }
}
